import React,{useState, useEffect, useRef} from 'react'
import Navbar from '../../Components/Navbar/navbar'
import Topbarsub from '../../Components/Topbar/Topbarsub'
import '../Employee/employee.css'
import './events.css'
import EventList from './eventsList'
import ButtonPagenate from '../../Components/ButtonPagenate/ButtonPagenate'
import Boardcard from '../../Components/Boardcard/Boardcard'
import EventScript from './eventScript'
import Action from '../../Components/Action/Action'


const UpcomingEvent = ({page, addnewoverlay, urole}) => {
  page = 'event'
  const fetchResultRef = useRef(false)

  const [objct, setObjct] = useState({
    upcoming: 0,
    canceled: 0,
    rescheduled: 0
  })

  useEffect(() =>{
    if(fetchResultRef.current) return;
    fetchResultRef.current = true
    Result()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const Result = () =>{
    EventList.map(async (items) =>{
    var current = +new Date();
    let pastdate = items.stdate.split('-')
    let start = +new Date(pastdate[2] + '-' + pastdate[1] + '-' + pastdate[0]);

    if(items.startus === 1 && current < start){
      setObjct({...objct, upcoming: ++objct.upcoming})
    } if(items.startus === 0 && (current < start)){
      setObjct({...objct, rescheduled: ++objct.rescheduled})
    } if(items.startus === 0 && (current > start)){
      setObjct({...objct, canceled: ++objct.canceled})
    }
  })}
  
  const [searchcriteria, setSearchcriteria] = useState("")
  const [nameSearch, setNameSearch] = useState("")

  const [pageNumber, setPageNumber] = useState(0);
  const itemsPerpage = 8; //Number of items to be displayed per page 
  const pageCount = Math.ceil(EventList.length / itemsPerpage);
  const pagesVisited = pageNumber * itemsPerpage;
  const eventleng = EventList.length
  //   const API = 'https://admin.sabrecwa.com/backend'

  const handleSearchCriteria = (incoming) =>{
    setSearchcriteria(incoming)
  }

  const filterSearch = (incoming) =>{
    setNameSearch(incoming.toString())
  }

  const newPagenum = (num) =>{
    setPageNumber(num)
  }

  const handleaddOverlay = (incoming) =>{
    addnewoverlay(incoming)
  }

  const handleselectedVal = (incoming) =>{
    // console.log(incoming)
  }

  // <EventScript status={items.startus} startdate={items.stdate} endDate={items.endate}/> === 'UPCOMING' ? 'upstatus' : <EventScript status={items.startus} startdate={items.stdate} endDate={items.endate}/> === 'CANCELED' ? 'cancstatus' :  'complstatus'
  
  return (
    <div className='treated-appraisal-container'>
      <Navbar tabtext="Event Handler" currentab='others'/>
      <Topbarsub role={urole.role} serchCriteria={handleSearchCriteria} currrenTab={page} searchword={filterSearch} addoverlay={handleaddOverlay}/>
      <div className='tretapp-card-container'>
            <Boardcard val={objct.upcoming} name="Upcoming Events" maxV={eventleng} minV={0}/>
            <Boardcard val={objct.rescheduled} name="Rescheduled Events" maxV={eventleng} minV={0}/>
            <Boardcard val={objct.canceled} name="Canceled Events" maxV={eventleng} minV={0}/>
        </div>

      <div className='comp-list-table-containerr'>
                <table>
                    <thead>
                        <tr>
                            <th scope="col">EID</th>
                            <th scope="col">Event</th>
                            <th scope="col">Start Date</th>
                            <th scope="col">End Date</th>
                            <th scope="col">Status</th>
                            {urole.role !== 'STAFF' ? <th scope="col">Action</th> : ""}
                        </tr>
                    </thead>
                    <tbody>
                        {EventList.reverse().slice(pagesVisited, pagesVisited + itemsPerpage).map((items) =>(
                            <tr>
                                <td data-label="EID">{items.ID}</td>
                                <td data-label="Event">{items.event}</td>
                                <td data-label="Start Date">{items.stdate}</td>
                                <td data-label="End Date">{items.endate}</td>
                                <td data-label="Status">
                                    <EventScript status={items.startus} startdate={items.stdate} endDate={items.endate}/>
                                </td>
                               {urole.role !== 'STAFF' ? <td data-label="Action"><Action actionsta={items.event.includes('Birthday') ? true : false} clickedval={handleselectedVal}/></td> : ""}
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className='papp-table-pgnate-contain'>
                    <ButtonPagenate 
                    updatedPageNum={newPagenum}
                    pageCount={pageCount}
                    pageNumber={pageNumber}
                    previousLabel="Prev"
                    nextLabel="Next"/>
                </div>
      </div>
    </div>
  )
}

export default UpcomingEvent